(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sibling-swatches-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.sib-card-swatch');
    if (!swatch) return;

    const wrapper = swatch.closest('[data-sib-swatches]');
    const card = swatch.closest('.m-product-card');
    if (!wrapper || !card) return;

    event.preventDefault();

    const source = swatch.dataset.sibImage;
    if (source) {
      card.querySelectorAll('.m-product-card__main-image img, .m-product-card__hover-image img').forEach((image) => {
        image.removeAttribute('srcset');
        image.src = source;
      });
    }

    const destination = swatch.getAttribute('href');
    if (destination) {
      card.querySelectorAll('a.m-product-card__link, a.m-product-card__name').forEach((link) => {
        link.href = destination;
      });
    }

    wrapper.querySelectorAll('.sib-card-swatch').forEach((item) => item.classList.remove('is-active'));
    swatch.classList.add('is-active');
  });
  } catch(e) { console.error(e); }
})();

})();
